// extracted by mini-css-extract-plugin
export default {"root":"Button_root__G90-y","disabled":"Button_disabled__JpZxX","placeHolderShimmer":"Button_placeHolderShimmer__HAWzm"};